import { render, staticRenderFns } from "./contentDaftarPensiun.vue?vue&type=template&id=5b123dcc&"
import script from "./contentDaftarPensiun.vue?vue&type=script&lang=js&"
export * from "./contentDaftarPensiun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports